import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import DialogWrapper from "components/DialogWrapper";

const CheckInInfo = (props) => {
    const { open, setOpen } = props;
    return (
        <DialogWrapper
            title=" New Check-In Requirement: Timesheet Compliance"
            open={open}
            setOpen={setOpen}
            width="lg"
        >
            <Box sx={{ padding: 2, backgroundColor: '#f9f9f9', borderRadius: 2 }}>
                <Typography variant="h6" component="h2" gutterBottom>
                    To ensure seamless project tracking, we are introducing a new validation for the Check-In button.
                </Typography>
                <Typography variant="body1" gutterBottom>
                    <Typography variant="h6" component="h2" gutterBottom>
                        What’s Changing?
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        Starting now, you can only check in if your previous timesheets from the last 15 days are complete.
                    </Typography>

                    <Typography variant="h6" component="h2" gutterBottom>
                        The Criteria:
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        Standard Hours: Timesheets must be filled with at least the standard working hours or the actual time spent in the office.
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        Leaves/Holidays: If your previous day was a holiday or leave, the system will automatically check the last active working day within the 15-day window.
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        Extended Absence: If you have been on leave or if there have been holidays for more than 15 consecutive days, the validation is waived, and you can check in directly.
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        Please ensure your timesheets are up to date to avoid any interruptions during your morning check-in!
                    </Typography>
                </Typography>
            </Box>
        </DialogWrapper>
    )
}

export default CheckInInfo